var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M 107.0625 56.226562 C 107.0625 27.910156 84.175781 4.953125 55.945312 4.953125 C 27.714844 4.953125 4.832031 27.910156 4.832031 56.226562 C 4.832031 81.820312 23.523438 103.03125 47.960938 106.875 L 47.960938 71.046875 L 34.980469 71.046875 L 34.980469 56.226562 L 47.960938 56.226562 L 47.960938 44.929688 C 47.960938 32.082031 55.589844 24.984375 67.265625 24.984375 C 72.859375 24.984375 78.710938 25.984375 78.710938 25.984375 L 78.710938 38.601562 L 72.265625 38.601562 C 65.914062 38.601562 63.933594 42.554688 63.933594 46.609375 L 63.933594 56.226562 L 78.109375 56.226562 L 75.84375 71.046875 L 63.933594 71.046875 L 63.933594 106.875 C 88.371094 103.03125 107.0625 81.820312 107.0625 56.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 75.84375 71.046875 L 78.109375 56.226562 L 63.933594 56.226562 L 63.933594 46.609375 C 63.933594 42.554688 65.914062 38.601562 72.265625 38.601562 L 78.710938 38.601562 L 78.710938 25.984375 C 78.710938 25.984375 72.859375 24.984375 67.265625 24.984375 C 55.589844 24.984375 47.960938 32.082031 47.960938 44.929688 L 47.960938 56.226562 L 34.980469 56.226562 L 34.980469 71.046875 L 47.960938 71.046875 L 47.960938 106.875 C 50.605469 107.292969 53.269531 107.5 55.945312 107.5 C 58.664062 107.5 61.332031 107.285156 63.933594 106.875 L 63.933594 71.046875 L 75.84375 71.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.0aaadb827687006878d86f1657b7eab3.svg";
export { ForwardRef as ReactComponent };